import React from "react";

const skills = [
  {
    title: "Programming",
    items: ["JavaScript", "TypeScript", "Python", "Java"],
  },
  {
    title: "Frontend",
    items: ["React", "Next.js", "Vite", "Tailwind", "Three.js"],
  },
  {
    title: "Mobile",
    items: ["React Native"],
  },
  {
    title: "Backend",
    items: ["Node.js", "Express", ".NET"],
  },
  {
    title: "Databases",
    items: ["PostgreSQL", "MongoDB"],
  },
  {
    title: "AI & Agents",
    items: [
      "OpenAI",
      "LangChain",
      "RAG",
      "AI Agents",
      "Prompt Engineering",
      "PyTorch",
      "TensorFlow",
    ],
  },
  {
    title: "Cloud & DevOps",
    items: [
      "Docker",
      "Supabase",
      "Firebase",
      "Microsoft Azure",
      "Google Cloud",
    ],
  },
  {
    title: "Tools",
    items: ["Git", "GitHub", "GitLab"],
  },
];

const Skills = () => {
  return (
    <section id="skills" className="w-full bg-[#0d0d0d] py-20">
      {/* Header */}
      <div className="px-6 md:px-10">
        <h2 className="text-5xl md:text-6xl font-semibold tracking-tight text-white/90">
          Technical Skills
        </h2>
      </div>

      {/* Content */}
      <div className="mt-12 px-6 md:px-10">
        <div className="space-y-6 md:space-y-7">
          {skills.map((s) => (
            <div
              key={s.title}
              className="grid grid-cols-1 md:grid-cols-[300px_1fr] gap-3 md:gap-8 items-start"
            >
              {/* Title */}
            <h3 className="text-lg md:text-xl font-medium text-neutral-200">
                {s.title}
              </h3>

              {/* Items */}
            <p className="text-[16.5px] md:text-[18px] leading-relaxed text-neutral-400">
                {s.items.join(" · ")}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
